import { Sparkles } from 'lucide-react';
/**
 * AIRecommendationBanner.jsx
 *
 * ProductModal sub-component: renders the "Why AI Picked This" banner with a
 * confidence badge (high/medium/low) and reason text. Extracted from
 * ProductModal.jsx (Feb 2026) to reduce complexity.
 */

const CONFIDENCE_STYLES = {
  high: { bg: '#D1FAE5', text: '#065F46', label: '🟢 High Match' },
  medium: { bg: '#FEF3C7', text: '#92400E', label: '🟡 Good Match' },
  low: { bg: '#E5E7EB', text: '#374151', label: '⚪ Worth Considering' },
};

export function AIRecommendationBanner({ aiMetadata, darkMode }) {
  if (!aiMetadata) return null;

  const confidenceStyle =
    aiMetadata.confidence && CONFIDENCE_STYLES[aiMetadata.confidence];

  return (
    <div
      data-testid="ai-recommendation-banner"
      className="mb-6 p-5 rounded-xl transition-colors"
      style={{
        background: darkMode.isDark
          ? 'rgba(254, 215, 165, 0.1)'
          : 'rgba(139, 92, 246, 0.08)',
        border: `2px solid ${darkMode.isDark ? 'rgba(254, 215, 165, 0.3)' : 'rgba(139, 92, 246, 0.2)'}`,
      }}
    >
      <div className="flex items-start gap-3 mb-3">
        <div
          className="p-2 rounded-lg"
          style={{
            background: darkMode.isDark
              ? 'rgba(254, 215, 165, 0.2)'
              : 'rgba(139, 92, 246, 0.15)',
          }}
        >
          <Sparkles
            className="w-5 h-5"
            style={{ color: darkMode.isDark ? '#FED7A5' : '#8B5CF6' }}
          />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h4
              className="font-bold text-base transition-colors"
              style={{ color: darkMode.textPrimary }}
            >
              Why AI Picked This
            </h4>
            {confidenceStyle && (
              <span
                className="px-2.5 py-1 rounded-full text-xs font-semibold"
                style={{ background: confidenceStyle.bg, color: confidenceStyle.text }}
              >
                {confidenceStyle.label}
              </span>
            )}
          </div>
          <p
            className="text-sm leading-relaxed transition-colors"
            style={{ color: darkMode.textSecondary }}
          >
            {aiMetadata.reason}
          </p>
        </div>
      </div>
      <div
        className="text-xs pt-3 border-t transition-colors"
        style={{
          borderColor: darkMode.isDark
            ? 'rgba(254, 215, 165, 0.2)'
            : 'rgba(139, 92, 246, 0.15)',
          color: darkMode.textSecondary,
        }}
      >
        💡 This recommendation is based on questionnaire responses and product tags
      </div>
    </div>
  );
}
